// src/components/OutcomeModal/OutcomeModal.js
import React from 'react';
import './OutcomeModal.css';

const OutcomeModal = ({isOpen, onClose}) => {
    if (!isOpen) return null;

    const categories = [
        {label: 'Disconnected', colorClass: 'gray'},
        {label: 'Reschedule', colorClass: 'blue'},
        {label: 'Follow-Up Needed', colorClass: 'yellow'},
        {label: 'Deal Closed - Won', colorClass: 'green'},
        {label: 'Deal Closed - Lost', colorClass: 'red'},
        {label: 'Price Objection', colorClass: 'orange'},
        {label: 'Needs More Info', colorClass: 'purple'},
        {label: 'Unqualified Lead', colorClass: 'teal'}
    ];

    return (
        <div className="outcome-modal-overlay">
            <div className="outcome-modal-content">
                <div className="outcome-modal-header">
                    <h4>Post Call Outcome</h4>
                    <button className="modal-close-btn" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="outcome-modal-body">
                    <p>Please select the outcome of this call:</p>
                    <div className="post-actions-grid">
                        {categories.map((category, index) => (
                            <div key={index} className={`cat-box ${category.colorClass}`}>
                                {category.label}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="outcome-modal-footer">
                    <button className="answer-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OutcomeModal;